import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ErrorBoundary from "./components/common/ErrorBoundary";
import { logEvent, serializeError } from "./utils/logger";

// --- Listeners globaux pour erreurs JS non capturées ---

window.addEventListener("error", (event) => {
  logEvent("CRITICAL", "SYSTEM", "Uncaught Global Error", {
    error: {
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      stack: event.error?.stack || null,
    },
  });
});

window.addEventListener("unhandledrejection", (event) => {
  logEvent("ERROR", "SYSTEM", "Unhandled Promise Rejection", {
    error: {
      message: event.reason?.message || String(event.reason),
      stack: event.reason?.stack || null,
    },
  });
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
